export default "__VITE_ASSET__B0N5vqjc__"